import {useBoolean} from 'minimal-shared/hooks';
import {useCallback, useEffect, useState} from 'react';

import {CONFIG} from '@minimal/global-config';
import {authProvider} from '@providers/security/auth-provider';

export type WorkspaceType = {
  id: WorkspaceList;
  name: string;
  basePath: string;
  logo?: string;
};

export enum WorkspaceList {
  GLOBAL = 'global',
  BDESE = 'bdese',
  NEMESIS = 'nemesis',
  PILOTAGE_RH = 'pilotage-rh',
}

export const workspacesBaseApi: Record<WorkspaceList, string> = {
  [WorkspaceList.GLOBAL]: 'global',
  [WorkspaceList.BDESE]: 'bdese',
  [WorkspaceList.NEMESIS]: 'nemesis',
  [WorkspaceList.PILOTAGE_RH]: 'pilotage-rh',
};

export const workspacesBasePath: Record<WorkspaceList, string> = {
  [WorkspaceList.GLOBAL]: '/',
  [WorkspaceList.BDESE]: '/bdese',
  [WorkspaceList.NEMESIS]: '/nemesis',
  [WorkspaceList.PILOTAGE_RH]: '/pilotage-rh',
};

const workspacesLogo: Record<WorkspaceList, string> = {
  [WorkspaceList.GLOBAL]: 'tissot.svg',
  [WorkspaceList.BDESE]: 'bdese.svg',
  [WorkspaceList.NEMESIS]: 'tissot.svg',
  [WorkspaceList.PILOTAGE_RH]: 'tissot.svg',
};

export const WorkspaceValues = Object.values(WorkspaceList);

export const workspaces: WorkspaceType[] = WorkspaceValues.map((workspace) => ({
  id: workspace,
  name: `menu.workspace.${workspace}`,
  basePath: workspacesBasePath[workspace],
  logo: `${CONFIG.assetsDir}/assets/logos/${workspacesLogo[workspace]}`,
}));

export const useUserWorkspaces = (): {loading: boolean; userWorkspaces: WorkspaceType[]} => {
  const loading = useBoolean(true);
  const [workspacesType, setWorkspacesType] = useState<WorkspaceType[]>([]);

  const fetchWorkspaces = useCallback(async () => {
    const permissions = await authProvider.getPermissions?.();
    if (!permissions) {
      return;
    }
    setWorkspacesType(workspaces.filter((workspace) => permissions.workspaces.includes(workspace.id)));
    loading.setValue(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchWorkspaces();
  }, [fetchWorkspaces]);

  return {
    loading: loading.value,
    userWorkspaces: workspacesType,
  };
};
